import 'bootstrap.collapse';
import 'configure-default-runtime';
import 'fancybox';
import 'global';
import { isNumber, parseNumber } from 'intl-utils';
import { onLoad } from 'runtime';
import { fetch } from 'utils';
import '/assets/theme/js/mmenu-light.js';

const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 992px)');

menu.navigation({
    slidingSubmenus: true,
    title: 'Menu'
});

const drawer = menu.offcanvas({
    position: 'left'
});

// Open the menu.
document.querySelector('button[href="#menu-navbar"]')
    .addEventListener('click', e => {
        e.preventDefault();
        drawer.open();
    });

// Back to top after set scroll add class to show it.
window.addEventListener('scroll', function() {
    var backToTop = document.getElementById('back-to-top');

    if (backToTop) {
        if (window.scrollY > 200) {
            backToTop.style.opacity = 1;
            backToTop.style.pointerEvents = 'auto'; // Make it clickable
        } else {
            backToTop.style.opacity = 0;
            backToTop.style.pointerEvents = 'none'; // Make it non-clickable
        }
    }

    const parallaxImage = document.querySelector('.parallax-image');

    if (parallaxImage) {
        let scrollPosition = window.pageYOffset;

        // Adjust the scroll speed factor (e.g., 0.3) to control the parallax effect
        parallaxImage.style.transform = 'translateY(' + scrollPosition * 0.3 + 'px)';
    }
});

let lastScroll = 0; // Define lastScroll in the local scope

window.addEventListener('scroll', function() {
    const currentScroll = window.scrollY;
    const header = document.querySelector("#app > header");

    if (!header) return; // Exit if the header is not found

    if (currentScroll <= 300) {
        // Less than or equal to 300px from the top, ensure header is visible
        header.style.opacity = 1;
        header.style.pointerEvents = 'auto'; // Make it clickable
    } else if (currentScroll > lastScroll) {
        // Scrolling down
        header.style.opacity = 0;
        header.style.pointerEvents = 'none'; // Make it non-clickable
    } else if (lastScroll - currentScroll > 50) {
        // Scrolling up more than 50px
        header.style.opacity = 1;
        header.style.pointerEvents = 'auto'; // Make it clickable
    }

    lastScroll = currentScroll; // Update lastScroll for the next scroll event
});

onLoad(context => {
    scrollRevealOnScroll(context, '.scroll-reveal', 'fade-in-up');
    scrollRevealOnScroll(context, '.scroll-reveal-scale', 'fade-in-scale');
    scrollRevealOnScroll(context, '.scroll-reveal-left', 'fade-in-left');
    scrollRevealOnScroll(context, '.scroll-reveal-right', 'fade-in-right');

    // Show and hide the additional information panels on the shop details page.
    context.querySelectorAll('.product-listing-details-panel').forEach(el => {
        el.addEventListener('click', () => {
            el.classList.toggle('open');
        })
    });

    context.querySelector('.search-open')?.addEventListener('click', () => {
        context.querySelector('#product-search').classList.toggle('active');
    });

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const href = e.target.getAttribute('href');
            const offsetTop = context.querySelector(href)?.offsetTop;

            window.scroll({
                top: offsetTop - 100,
                behavior: 'smooth'
            });
        });
    });

    // Show body text mobile read more (Shop only).
    context.querySelectorAll('.read-more-body').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault()
            e.target.classList.add('hide-btn');
            e.target.closest('.body-text-wrapper').querySelector('.body-text').classList.add('show-body');
        });
    });

    // Scroll To Top of page.
    context.querySelectorAll('.scroll-to-top').forEach(link => {
        link.addEventListener('click', e => {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        });
    });

    // Scroll to product listings if filters are included in url querystring.
    const url = window.location.href;
    const productListings = document.getElementById('product-listings');

    if (productListings !== null && url.toLowerCase().includes('filters'))
        window.scroll({
            top: productListings.offsetTop,
            behavior: 'smooth'
        });
});

// Scroll reveal styles
function scrollRevealOnScroll(context, revealSelector, animationClass) {
    var elements = context.querySelectorAll(revealSelector);
    if (elements.length === 0) return;

    function revealElements() {
        elements.forEach(function(element) {
            // Skip if already revealed
            if (element.classList.contains(animationClass)) return;

            var rect = element.getBoundingClientRect();
            var positionFromTop = rect.top;

            if (positionFromTop <= window.innerHeight && rect.bottom >= 0) {
                element.classList.add(animationClass);
            }
        });
    }

    // Reveal anything already visible shortly after load
    window.addEventListener('load', function() {
        setTimeout(revealElements, 100); // slight delay for smoother effect
    });

// Reveal on scroll
    window.addEventListener('scroll', revealElements);
}